// Gating for the public coach page at /coach/:uid/:profileUrl.
//
// The slug identifies the coach; the first URL segment must be that coach's
// `uid`. This is also what sunsets the legacy /coach/<user_id>/<slug> form —
// those links carried the sequential users.id, which made the coach directory
// enumerable by walking 1..N. See
// docs/superpowers/specs/2026-08-01-sequential-id-exposure-audit.md, finding 3.
//
// Match on VALUE, never on shape. `generate_unique_uid` mints an 8-digit
// zero-padded numeric string, so a uid and a user id are both all-digits and no
// regex can separate them — a /^\d+$/ "is this a legacy integer" test rejects
// every legitimate coach.

/**
 * @param {{user?: {uid?: string}}} payload response from GET /api/coaches/public/{slug}
 * @param {string} uidSegment the :uid segment of the current URL
 * @returns {boolean} true when the page may render this coach
 */
export function matchesCoachUid(payload, uidSegment) {
  const uid = payload?.user?.uid;
  if (!uid || !uidSegment) return false;
  return String(uid) === String(uidSegment);
}
